const KeenSlider = window.KeenSlider

const { setInitialised, addWheelControls, useArrows } =
  window.BAO.Carousel.plugins

class ProductMedia extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.carousel = this.setupCarousel()
  }

  setupListeners () {
    super.setupListeners()

    this.handleArrowClick = this.handleArrowClick.bind(this)

    if (this.els.previous?.exists) {
      this.listeners.add(
        this.els.previous.element,
        'click',
        this.handleArrowClick,
      )
    }

    if (this.els.next?.exists) {
      this.listeners.add(this.els.next.element, 'click', this.handleArrowClick)
    }

    if (!this.els.video?.exists) return

    this.handleVideoTrigger = this.handleVideoTrigger.bind(this)

    this.listeners.add(
      this.els.video.element,
      'click',
      this.handleVideoTrigger,
    )
  }

  setupCarousel () {
    this.onSlideChanged = this.onSlideChanged.bind(this)

    return new KeenSlider(
      this.els.slides.element,
      {
        selector: this.els.slide.selector,
        defaultAnimation: {
          duration: 1500,
        },
        loop: false,
        mode: 'snap',
        slides: {
          perView: 'auto',
          spacing: 1,
        },
        slideChanged: this.onSlideChanged,
      },
      [
        setInitialised(),
        addWheelControls('horizontal'),
        useArrows({
          next: this.els?.next?.element,
          previous: this.els?.previous?.element,
        }),
      ],
    )
  }

  onSlideChanged (instance) {
    const details = instance.track.details

    if (this.els.index?.exists) {
      this.els.index.element.innerText = details.rel + 1
    }

    if (this.els.video?.exists) {
      const currentSlide = instance.slides[details.rel]

      this.els.video.element.setAttribute(
        'aria-hidden',
        currentSlide.dataset.mediaType === 'video',
      )
    }

    this.gtmTrackGalleryProgress(details)
  }

  handleArrowClick () {
    sessionStorage.setItem('BAO-media-gallery-arrow-click', 'true')
  }

  handleVideoTrigger () {
    this.carousel.moveToIdx(
      parseInt(this.els.video.element.dataset.slideIndex),
    )
  }

  gtmTrackGalleryProgress (details) {
    if (details.progress === 0) return

    const isArrowClick = sessionStorage.getItem(
      'BAO-media-gallery-arrow-click',
    )
    const eventType = isArrowClick ? 'arrow click' : 'drag'
    const targetContext = 'pdp-gallery'
    const eventProgress = this.calculateProgress(details)

    this.trackGalleryConversionAttribution(eventProgress)

    window.dataLayer = window.dataLayer || []

    window.dataLayer.push({
      event: 'carousel_engagement',
      event_type: eventType,
      event_progress: eventProgress,
      target_context: targetContext,
      target_contextSize: details.slides.length,
    })

    if (!isArrowClick) return

    sessionStorage.removeItem('BAO-media-gallery-arrow-click')
  }

  calculateProgress (details) {
    const relativeSlide = details.rel
    const size = details.slides.length
    const slidesPerView = this.getSlidesPerView(details)

    const fullSlidesPerView = Math.floor(slidesPerView)
    const highestCurrentVisibleIndex = relativeSlide + fullSlidesPerView
    let percentageProgress = (highestCurrentVisibleIndex / size) * 100

    percentageProgress = percentageProgress > 100 ? 100 : percentageProgress

    return Math.round(percentageProgress / 10) * 10
  }

  getSlidesPerView (details) {
    const visibleSlides = details.slides.filter((slide) => {
      return slide.portion > 0
    })

    return visibleSlides.length || 1
  }

  trackGalleryConversionAttribution (percentageProgress) {
    const currentValue = sessionStorage.getItem(
      'BAO-add-to-cart-event-context',
    )
    const prefix = 'pdp-gallery-percentage-progress'

    if (currentValue === `${prefix}-76-100`) return

    let interactionProgress = `${prefix}-0-25`

    if (percentageProgress > 75) {
      interactionProgress = `${prefix}-76-100`
    } else if (percentageProgress > 50) {
      interactionProgress = `${prefix}-51-75`
    } else if (percentageProgress > 25) {
      interactionProgress = `${prefix}-26-50`
    }

    sessionStorage.setItem(
      'BAO-add-to-cart-event-context',
      interactionProgress,
    )
  }
}

if (!customElements.get('product-media')) {
  customElements.define('product-media', ProductMedia)
}
